import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import adminServices from '../../services/AdminServices'
import Loading from '../feedback/Loading'
import FetchError from '../feedback/FetchError'
import { useAuth } from '../../context/UserContext'
import ProductsTable from './ProductList'
import { FaSearch } from 'react-icons/fa'
import { IoMdAdd } from 'react-icons/io'
import BrandsList from '../admin/BrandsList'
import ModelsList from '../admin/ModelsList'
import CaetgoriesList from '../admin/CaetgoriesList'
import ProductModal from './ProductModal'
import { useSession } from '../../context/SessionContext'
import vendorServices from '../../services/VendorSevices'
import ProductStats from './ProductStats'

function ProductsTab() {
    const { user } = useAuth()
    const { brands, productTypes, models } = useSession()
    const [action, setAction] = useState(0)
    const [activeProduct, setActiveProduct] = useState()
    const [searchParams, setSearchParams] = useSearchParams()
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState()
    const [products, setProducts] = useState()
    const searchInputRef = useRef();
    const navigate = useNavigate();
    const location = useLocation();

    const currentOrdering = searchParams.get('ordering') || '';

    const getProducts = useCallback((params) => {
        setError()
        setLoading(true)

        // Choose service based on user type
        const service = user?.is_vendor ? vendorServices : adminServices;

        service.getProducts(params ? `?${params}` : '').then(
            res => {
                setProducts(res.data)
                setLoading(false)
            },
            err => {
                console.log(err);
                setError(err)
                setLoading(false)
            }
        )
    }, [user])

    useEffect(() => {
        getProducts()
    }, [getProducts])
    useEffect(() => { }, [loading])
    useEffect(() => { }, [error])
    useEffect(() => { }, [products])
    useEffect(() => { }, [activeProduct])
    useEffect(() => { }, [action])
    useEffect(() => {
        const params = searchParams.toString()
        if (params) {
            getProducts(params)
        }
    }, [getProducts, searchParams])

    const updateURL = (newParams, scroll = false) => {
        const newPath = {
            pathname: location.pathname,
            search: newParams.toString(),
        };
        navigate(newPath, { replace: true, state: { scroll } });
    };

    const handleOrderingChange = (e) => {
        const value = e.target.value;
        const params = new URLSearchParams(searchParams);

        if (value) {
            params.set('ordering', value);
        } else {
            params.delete('ordering');
        }
        params.delete('page');

        updateURL(params);
    };


    function changePageParam(page) {
        if (page) {
            setSearchParams((params) => {
                params.set("page", page)
                return params
            })
        } else {
            setSearchParams((params) => {
                params.delete("page")
                return params
            })
            getProducts()
        }
    }

    const handleSearch = (e) => {
        if (e.key === 'Enter') {
            const query = e.target.value.trim();
            setSearchParams(prev => {
                const newParams = new URLSearchParams(prev);
                if (query) {
                    newParams.set('search', query);
                } else {
                    newParams.delete('search');
                    getProducts()
                }
                newParams.delete('page');
                return newParams;
            });
        }
    };

    function openModal(action, product) {
        const openBtn = document.getElementById("product-open-btn")
        if (action === 0) {
            setAction(0)
        }
        if (action === 1) {
            setAction(1)
            setActiveProduct(product)
        }
        openBtn.click()
    }
    return (
        <div className='space-y-6'>
            {user?.is_admin && (
                <div className='space-y-6'>
                    <CaetgoriesList />
                    <BrandsList />
                    <ModelsList />
                </div>
            )}
            <ProductStats />
            <div className="flex justify-between items-center">
                <div className="">
                    <h1 className="text-2xl font-bold text-gray-800 ">Products</h1>
                    <p className="text-sm text-gray-600 dark:text-gray-300 mb-4 sm:mb-0">
                        Showing {products?.results?.length || 0} of {products?.count || 0} products
                    </p>
                </div>


                <button
                    onClick={() => openModal(0)}
                    className="w-full md:w-auto mt-4 md:mt-0 flex items-center justify-center px-4 py-2 bg-primary text-white font-medium rounded-lg hover:bg-red-800 transition-colors duration-200">
                    <span className="material-icons mr-2"><IoMdAdd /></span>
                    Add Product
                </button>
            </div>
            <ProductModal
                models={models}
                action={action}
                activeProduct={activeProduct}
                brands={brands}
                productTypes={productTypes}
                getProducts={getProducts}
            />
            <div className='space-y-6'>

                {loading ? (
                    <div className='py-9'>
                        <Loading />
                    </div>
                ) : (
                    <div>
                        {error ? (
                            <div><FetchError error={error} /></div>
                        ) : (
                            <div>
                                <div className="flex flex-col md:flex-row items-center justify-between mb-8">
                                    <div className="relative w-full md:w-80">
                                        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
                                            <FaSearch />
                                        </span>
                                        <input
                                            ref={searchInputRef}
                                            className="w-full pl-10 pr-10 py-2 border rounded-lg focus:ring-primary focus:border-primary"
                                            placeholder="Search by name, brand, model ..."
                                            type="text"
                                            onKeyDown={handleSearch}
                                            defaultValue={searchParams.get('search') || ''}
                                        />
                                    </div>
                                    <div className="flex flex-col sm:flex-row sm:items-center gap-2 mb-4 sm:mb-0">
                                        <p className="whitespace-nowrap">Sort By:</p>
                                        <select
                                            className="select w-full sm:w-auto border"
                                            value={currentOrdering}
                                            onChange={handleOrderingChange}
                                        >
                                            <option value="">Default</option>
                                            <option value="-creation_time">Newest</option>
                                            <option value="creation_time">Oldest</option>
                                            <option value="price">Price: Low to High</option>
                                            <option value="-price">Price: High to Low</option>
                                            <option value="name">Name: A to Z</option>
                                            <option value="-name">Name: Z to A</option>
                                            <option value="quantity">Quantity: Low to High</option>
                                            <option value="-quantity">Quantity: High to Low</option>
                                        </select>
                                    </div>
                                </div>
                                <ProductsTable
                                    openModal={openModal}
                                    products={products}
                                    changePageParam={changePageParam}
                                />
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    )
}

export default ProductsTab